import NewslettersForm from "./NewslettersForm";

export default NewslettersForm;
